<template>
  <div></div>
</template>

<script lang="ts">
import { ERROR_CODE } from "@/constants";
import { AuthServiceSymbol, injectStrict } from "@/services/injection";
import { useGlobalErrorStore } from "@/stores/global.error";
import _ from "lodash";
import { defineComponent } from "vue";

export default defineComponent({
  name: "AppOidcCallback",
  async created() {
    const globalError = useGlobalErrorStore();
    try {
      const authService = injectStrict(AuthServiceSymbol);
      const result = await authService.signInRedirectCallback();
      const path = result?.state as string;
      this.$router.replace(parseUrl(path));
    } catch (e) {
      console.log(e);
      globalError.redirect(ERROR_CODE.AUTHENTICATION_SERVER, this.$router);
    }
  },
});

function parseUrl(url: string): {
  path: string;
  query: Record<string, string | string[]>;
} {
  const [path, queryString] = url.split("?");
  const query: Record<string, string | string[]> = {};

  if (queryString) {
    queryString.split("&").forEach((param) => {
      const [name, value] = param.split("=");
      if (name) {
        if (query[name]) {
          if (Array.isArray(query[name])) {
            (query[name] as string[]).push(value);
          } else {
            query[name] = [query[name] as string, value];
          }
        } else {
          query[name] = value;
        }
      }
    });
  }
  return { path, query };
}
</script>
